import React from "react";
//#region types
import { WidgetAreaProps } from "models/propTypes/homePropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { ComponentHiddenStatus } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const TodoWidgetArea: React.FC<WidgetAreaProps> = (props) => {
  return (
    <Grid container rowGap={3}>
      {props.children.map((childElem, index) => (
        <ComponentHiddenStatus
          key={index}
          render={(isHidden, setIsHidden) => (
            <Grid item xs={12} className={isHidden ? cssExports.hidden : ""}>
              {React.cloneElement(childElem, {
                onVisibilityChange: setIsHidden,
              })}
            </Grid>
          )}
        />
      ))}
    </Grid>
  );
};

export default TodoWidgetArea;
